import { config } from 'src/env.js';
import { showError, showSuccess } from '../redux/globalData/globalDataActionCreator';
const API_URL = `${config.apis.fundsRequestsApi.URL}`;

export const getQueryParams = (params = {}) => {
    return new URLSearchParams({
        page: params.page || 0,
        size: params.size || 10,
        sort: params.sort || 'id,asc',
        ...params
    }).toString();
};

export const payrollService = {
    getPayrollList: async (accessToken, params) => {
        try {
            const queryParams = getQueryParams(params);
            const response = await fetch(`${API_URL}/wage-manager?${queryParams}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
            });
            return await response.json();
        } catch (error) {
            console.error("Error fetching data:", error);
            throw error;
        }
    },

    getPayrollById: async (accessToken, payrollId) => {
        try {
            const response = await fetch(`${API_URL}/wage-manager/${payrollId}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
            });
            return await response.json();
        } catch (error) {
            console.error("Error fetching payroll detail:", error);
            throw error;
        }
    },

    createPayroll: async (accessToken, payrollData) => {
        try {
            const response = await fetch(`${API_URL}/wage-manager`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payrollData)
            });
            if (response.ok) {
                showSuccess("Liquidación creada correctamente");
            } else {
                const errorData = await response.json();
                showError(`Error al crear la liquidación: ${errorData.message || ''}`);
            }
            return response;
        } catch (error) {
            console.error("Error creating payroll:", error);
            showError(`Error al crear la liquidación: ${error.message || ''}`);
            throw error;
        }
    },

    updatePayroll: async (accessToken, payrollId, payrollData) => {
        try {
            const response = await fetch(`${API_URL}/wage-manager/${payrollId}`, {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payrollData)
            });
            return response;
        } catch (error) {
            console.error("Error creating payroll:", error);
            throw error;
        }
    },
    
    deletePayroll: async (accessToken, payrollId) => {
        try {
            const response = await fetch(`${API_URL}/wage-manager/${payrollId}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
            });
            if (response.ok) {
                showSuccess("Liquidación eliminada correctamente");
                return {
                    success: true,
                    response: response
                };
            } else {
                const errorData = await response.json();
                const errorMessage = errorData.message || 'Error al eliminar la liquidación';
                showError(`Error al eliminar la liquidación: ${errorMessage}`);
                return {
                    success: false,
                    error: errorMessage,
                    response: response
                };
            }
        } catch (error) {
            console.error("Error deleting payroll:", error);
            const errorMessage = error.message || 'Error al eliminar la liquidación';
            showError(`Error al eliminar la liquidación: ${errorMessage}`);
            return {
                success: false,
                error: errorMessage
            };
        }
    }
}
